var _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYouTube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20 40C22.6264 40 25.2272 39.4827 27.6537 38.4776C30.0802 37.4725 32.285 35.9993 34.1421 34.1421C35.9993 32.285 37.4725 30.0802 38.4776 27.6537C39.4827 25.2272 40 22.6264 40 20L20 20V40Z",
    fill: "#2F9CEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M0 20C-2.2961e-07 22.6264 0.517315 25.2272 1.52241 27.6537C2.5275 30.0802 4.00069 32.285 5.85786 34.1421C7.71504 35.9993 9.91982 37.4725 12.3463 38.4776C14.7728 39.4827 17.3736 40 20 40L20 20L0 20Z",
    fill: "#2F9CEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M40 20C40 17.3736 39.4827 14.7728 38.4776 12.3463C37.4725 9.91982 35.9993 7.71504 34.1421 5.85786C32.285 4.00069 30.0802 2.5275 27.6537 1.52241C25.2272 0.517315 22.6264 -1.14805e-07 20 0C17.3736 1.14805e-07 14.7728 0.517316 12.3463 1.52241C9.91982 2.5275 7.71503 4.00069 5.85786 5.85787C4.00069 7.71504 2.5275 9.91982 1.52241 12.3463C0.517315 14.7728 -2.2961e-07 17.3736 0 20L20 20H40Z",
    fill: "#2F9CEB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_523_13004)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.6014 15.1531C29.4883 14.7276 29.2654 14.3393 28.9551 14.027C28.6448 13.7147 28.2579 13.4894 27.8332 13.3736C26.2695 12.9531 20.0195 12.9531 20.0195 12.9531C20.0195 12.9531 13.7695 12.9531 12.2059 13.3736C11.7811 13.4894 11.3942 13.7147 11.0839 14.027C10.7736 14.3393 10.5508 14.7276 10.4377 15.1531C10.0195 16.7236 10.0195 19.9986 10.0195 19.9986C10.0195 19.9986 10.0195 23.2736 10.4377 24.844C10.5508 25.2695 10.7736 25.6579 11.0839 25.9702C11.3942 26.2825 11.7811 26.5078 12.2059 26.6236C13.7695 27.044 20.0195 27.044 20.0195 27.044C20.0195 27.044 26.2695 27.044 27.8332 26.6236C28.2579 26.5078 28.6448 26.2825 28.9551 25.9702C29.2654 25.6579 29.4883 25.2695 29.6014 24.844C30.0195 23.2736 30.0195 19.9986 30.0195 19.9986C30.0195 19.9986 30.0195 16.7236 29.6014 15.1531Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.9766 22.9751V17.0273L23.2038 20.0012L17.9766 22.9751Z",
    fill: "#2F9CEB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_523_13004"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTube);
export default __webpack_public_path__ + "static/media/YouTube.69fa771f1e8cf8646299ab024230f6d0.svg";
export { ForwardRef as ReactComponent };